import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import DateFilterDropdown from "./Transaction/DateFilterDropdown ";
import Pagination from "../Common/Table/Pagination";
import MobilePagination from "../Common/Table/MobilePagination";

const TransactionComponent = ({transactionsList, lastCalculatedBalance, defaultData, rowCurrentPageData, sendCurrentPage, oldTransactionData}) => {
    const { t } = useTranslation();
    const { id } = useParams();
    const navigate = useNavigate();
    const formatter = new Intl.NumberFormat('de-DE', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
    const [transactionList, setTransactionList] = useState([]);
    const [rowCurrentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(15);

    useEffect(() => {
        setTransactionList(transactionsList)
        setCurrentPage(rowCurrentPageData)
    }, [transactionsList, rowCurrentPageData]);

    const paginatedTransactions = transactionList.slice(
        (rowCurrentPage - 1) * rowsPerPage,
        rowCurrentPage * rowsPerPage
    );
    const handleRedirect = (e, data) => {
        const date = moment(data.DocumentDate).format('YYYY-MM-DD');
        localStorage.setItem('d_comment', data.Document_comment ? data.Document_comment : "");

        navigate(`/customers/transaction/${data.Document}/${id}/${date}`)
    };
    const handleCurrentPage = (page) => {
        setCurrentPage(page);
        sendCurrentPage(page);
    };
    const handlePerPage = (newPageSize) => {
        setRowsPerPage(newPageSize);
        setCurrentPage(1);
    };
    const handleDateDataFromChild = (data) => {
        setCurrentPage(1);
        
        let previousBalance = 0;
        const transactionsWithBalanceAsc = defaultData.map(transaction => {
            const balance = previousBalance;
            previousBalance = balance + (transaction?.Credit ? (transaction.Credit) : (transaction.Debit));
            return { ...transaction, Balance: balance };
        });

        const fromDate = moment(data.fromDate, 'YYYY-MM-DD');
        const toDate = moment(data.toDate, 'YYYY-MM-DD');

        const filteredPrevious = transactionsWithBalanceAsc.filter(txn => {
            const txnDate = moment(txn.DocumentDate, 'YYYY-MM-DD');
            return txnDate.isSameOrAfter(fromDate, 'day') && txnDate.isSameOrBefore(toDate, 'day');
        });
        const filtered = oldTransactionData.filter(txn => {
            const txnDate = moment(txn.DocumentDate, 'YYYY-MM-DD');
            return txnDate.isSameOrAfter(fromDate, 'day') && txnDate.isSameOrBefore(toDate, 'day');
        });

        if(filteredPrevious.length > 0) {
            const addData = {
                "CustomerId": id,
                "Document": "",
                "DocumentDiscription": "previous_balance_check_added",
                "DocumentDate": "",
                "Credit": "",
                "Debit": "",
                "VATValue": "",
                "TotalValue": "",
                "Document_comment": "previous balance",
                "Balance": (filteredPrevious.length > 0) ? filteredPrevious[0].Balance : 0
            };
            const mergedArray = [...filtered, addData];
            setTransactionList(mergedArray);
        } else {
            setTransactionList(filtered);
        }
    };
    const clearFilter = () => {
        setTransactionList(oldTransactionData);
    };

    return (
        <div className="bg-white border border-white rounded-lg space-y-2 sm:space-y-0 shadow-around">
            <div className="flex sm:hidden justify-between items-center sm:space-x-2 p-2 sm:p-0">
                <div className="flex space-x-1">
                    <h1 className="text-light-400 font-medium capitalize">{t ('balance')}: </h1>
                    <div className="text-green-normal font-bold">{formatter.format(lastCalculatedBalance)} €</div>
                </div>
                <div className="flex items-center space-x-2">
                    {/* <SortFilterDropdown sendSortDataFromChild={handleSortDataFromChild} /> */}
                    <DateFilterDropdown sendDateDataFromChild={handleDateDataFromChild} sendCloseDataFromChild={clearFilter} />
                </div>
            </div>
            <div className="block sm:hidden my-2 sm:my-4 border-t border-background-normal"></div>
            <div className="sm:block hidden relative overflow-x-auto rounded-lg">
                <table className="w-full text-xs">
                    <thead className="text-gray-normal bg-background-normal">
                        <tr>
                            <th scope="col" className="font-normal p-4">
                                <div className="flex">
                                    <div className="mr-2 uppercase">
                                        { t('status')}
                                    </div>
                                </div>
                            </th>
                            <th scope="col" className="font-normal p-4">
                                <div className="flex">
                                    <div className="mr-2 uppercase">
                                        { t('document number')}
                                    </div>
                                </div>
                            </th>
                            <th scope="col" className="font-normal p-4">
                                <div className="flex">
                                    <div className="mr-2 uppercase">
                                        { t('date')}
                                    </div>
                                </div>
                            </th>
                            <th scope="col" className="font-normal p-4">
                                <div className="flex">
                                    <div className="mr-2 uppercase">
                                        { t('credited/debited')}
                                    </div>
                                </div>
                            </th>
                            <th scope="col" className="font-normal p-4">
                                <div className="flex">
                                    <div className="mr-2 uppercase">
                                        { t('running total')}
                                    </div>
                                </div>
                            </th>
                            <th scope="col" className="font-normal p-4">
                                <div className="flex">
                                    <div className="mr-2 uppercase">
                                        { t('document comment')}
                                    </div>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody className="">
                        {paginatedTransactions.map((transaction, index) => (
                            (transaction.DocumentDiscription !== 'previous_balance_check_added') ?
                                <tr key={`transaction${index}`} onClick={(e) => handleRedirect(e, transaction)} className="bg-white border-b border-dashed hover:bg-gray-50 cursor-pointer">
                                    <td className="p-4 font-semibold">
                                        <div className="flex space-x-2 items-center">
                                            <img className="border border-blue-normal bg-blue-normal rounded-lg p-1" src={`../../assets/icons/profile/arrow-${transaction?.Credit ? 'down' : 'up'}.svg`} alt="arrow" />
                                            {transaction?.Credit ? (
                                                <div className="capitalize">{ t('payment received')}</div>
                                            ) : (
                                                <div className="capitalize">{ t('invoice sent')}</div>
                                            )}
                                        </div>
                                    </td>
                                    <td className="p-4">
                                        {transaction.Document}
                                    </td>
                                    <td className="p-4">
                                        {moment(transaction.DocumentDate).format("DD/MM/YYYY")}
                                    </td>
                                    <td className={(transaction?.Credit ? 'text-green-normal' : 'text-purple-dark') + " p-4 font-semibold"}>
                                        {transaction?.Credit ? (
                                            formatter.format(transaction.Credit)
                                        ) : (
                                            formatter.format(transaction.Debit)
                                        )}
                                        <span className="ml-0.5">€</span>
                                    </td>
                                    <td className="p-4">
                                        {formatter.format(transaction.Balance.toFixed(2))} €
                                    </td>
                                    <td className="p-4">
                                        {transaction.Document_comment}
                                    </td>
                                </tr>
                            :
                                <tr key={`transactionPrevious`} className="bg-white border-b border-dashed hover:bg-gray-50">
                                    <td className="p-4">
                                    </td>
                                    <td className="p-4">
                                    </td>
                                    <td className="p-4">
                                    </td>
                                    <td className="p-4 capitalize">
                                        {transaction.Document_comment}
                                    </td>
                                    <td className="p-4">
                                        {formatter.format(transaction.Balance.toFixed(2))} €
                                    </td>
                                    <td className="p-4">
                                    </td>
                                </tr>
                        ))}
                    </tbody>
                </table>
                {transactionList.length > 0 ? 
                    <Pagination
                        currentPage={rowCurrentPage}
                        totalCount={transactionList.length}
                        pageSize={rowsPerPage}
                        perPageCount={paginatedTransactions.length}
                        onPageChange={handleCurrentPage}
                        onPageSizeChange={handlePerPage}
                    />
                    :
                    <div className="p-6 text-center font-bold text-xs sm:text-xl rounded-lg capitalize bg-white shadow-around">
                        { t('no records available')}
                    </div>
                }
            </div>
            <div className="sm:hidden block bg-white border border-white rounded-lg space-y-3 p-2">
                {paginatedTransactions.map((transaction, index) => (
                    (transaction.DocumentDiscription !== 'previous_balance_check_added') ?
                    <div key={`transaction${index}`}>
                        <div onClick={(e) => handleRedirect(e, transaction)} className="cursor-pointer hover:bg-gray-50 w-full">
                            <div className="flex space-x-2 items-center w-full">
                                <img className="border border-blue-normal bg-blue-normal rounded-lg p-1 w-8 h-8" src={`../../assets/icons/profile/arrow-${transaction?.Credit ? 'down' : 'up'}.svg`} alt="arrow" />
                                <div className="flex flex-col space-y-1.5 w-full">
                                    <div className="flex items-center justify-between">
                                        {transaction?.Credit ? (
                                            <div className="text-xs capitalize font-semibold">{ t('payment received')}</div>
                                        ) : (
                                            <div className="text-xs capitalize font-semibold">{ t('invoice sent')}</div>
                                        )}
                                        <div className={(transaction?.Credit ? 'text-green-normal' : 'text-purple-dark') + " text-xs font-semibold"}>
                                            {transaction?.Credit ? (
                                                formatter.format(transaction.Credit)
                                            ) : (
                                                formatter.format(transaction.Debit)
                                            )}
                                            <span className="ml-0.5">€</span>
                                        </div>
                                    </div>
                                    <div className="text-[10px] flex items-center space-x-1">
                                        <div className="font-medium">{transaction.Document}</div>
                                        <div className="border-l border-gray-400 h-3"></div>
                                        <div className="text-light-400">{moment(transaction.DocumentDate).format("DD/MM/YYYY")}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="flex items-center justify-end">
                                <div className="text-[10px] capitalize">{ ("running total")}: {formatter.format(transaction.Balance.toFixed(2))} €</div>
                            </div>
                        </div>
                        <div className="my-1 border-t border-dashed border-background-normal block sm:hidden"></div>
                    </div>
                    :
                    <div key={`transactionPrevious`}>
                        <div className="flex items-center justify-end">
                            <div className="text-sm font-medium capitalize text-light-400">{ ("previous balance")}: {formatter.format(transaction.Balance.toFixed(2))} €</div>
                        </div>
                        <div className="my-3 border-t border-dashed border-background-normal block sm:hidden"></div>
                    </div>
                ))}
                {transactionList.length > 0 ? 
                    <MobilePagination
                        currentPage={rowCurrentPage}
                        totalCount={transactionList.length}
                        pageSize={rowsPerPage}
                        perPageCount={paginatedTransactions.length}
                        onPageChange={handleCurrentPage}
                        onPageSizeChange={handlePerPage}
                    />
                :
                    <div className="p-6 text-center font-bold text-xs sm:text-xl rounded-lg capitalize bg-white shadow-around">
                        { t('no records available')}
                    </div>
                }
            </div>
        </div>
    )
}

export default TransactionComponent;